// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	function resizeWindow(){

	}
	function scrollDown(){
		let top = $(document).scrollTop();
		if (top > 0) {

		} else {

		}
	}
	
	$(document).ready(function () {

		//Call function with browser is resized.
		$(window).resize(function (event) {
			resizeWindow();
		});
		resizeWindow();

		//Acts when scroll down page.
		$(window).scroll(function (event) {
			scrollDown();
		});

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		// RESTAURANT MENUS FILTER
		document.querySelectorAll('.restMenus_filter li').forEach((btn, i) => {
			btn.addEventListener('click', _ => {
				document.querySelectorAll('.restMenus_filter li').forEach(b => b.classList.remove('active'));
				btn.classList.add('active');

				document.querySelectorAll('.restMenus_item').forEach((room, j) => {
					room.classList.remove('active');
					if ( btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag ) {
						room.classList.add('active');
						document.querySelectorAll('.restMenus_item')[j].querySelectorAll('.categories-menu li')[0].click();
					}
				});
				
			});
			

			if (i === 0) btn.click();

		});

		document.querySelectorAll('.categories-menu li').forEach((btn, i) => {
			btn.addEventListener('click', _ => {
				document.querySelectorAll('.categories-menu li').forEach(b => b.classList.remove('active'));
				btn.classList.add('active');

				document.querySelectorAll('.restMenus_cat').forEach(cat => {
					cat.classList.remove('active');
					if ( btn.dataset.tag === 'all' || btn.dataset.tag === cat.dataset.tag ) {
						cat.classList.add('active');
					}
				});
			});

			if (i === 0) btn.click();
		});


		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})

		document.querySelector('body').classList.add('loaded');
	};

	//SVG titles

	const svg_titles = document.getElementsByClassName('svg-title');
	for(let i = 0; i < svg_titles.length; i++){
		const this_span = svg_titles[i].querySelector('span');
		const thisText = this_span.innerHTML;

		this_span.innerHTML = 	'<svg width="1100" height="140" viewbox="0 0 1100 110" xmlns="http://www.w3.org/2000/svg">'+
				'<defs><linearGradient id="gradient" y1="0" y2="1"><stop stop-color="#b0876f" offset="0"/><stop stop-color="#000" offset="1"/></linearGradient></defs>' +
									'<text x="50%" y="105" text-anchor="middle"  stroke="url(#gradient)">'+thisText+'</text>'+
								'</svg>';
	}

	const svg_numbers = document.getElementsByClassName('counter-numbers');
	for(let i = 0; i < svg_numbers.length; i++){
		const this_span = svg_numbers[i].querySelector('span');
		const thisText = this_span.innerHTML;

		this_span.innerHTML = 	'<svg width="500" height="300" viewbox="0 0 500 290" xmlns="http://www.w3.org/2000/svg">'+
									'<text x="50%" y="290" text-anchor="middle">'+thisText+'</text>'+
								'</svg>';
	}


}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

	const window_height = window.innerHeight;
	let animatedEl = document.getElementsByClassName('animate-fade-2');
	for (let i = 0; i < animatedEl.length; i++) {
		var viewportOffset = animatedEl[i].getBoundingClientRect();
		let topPos = viewportOffset.top;
		if(topPos <= window_height*0.8){
			animatedEl[i].classList.add('fade-in');
		}
	}

}

$('.sym-slides').slick({
	accessibility: false,
	prevArrow: '<button type="button" class="slick-prev">Prev</button>'
});

